import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {AutoDisablingButton} from "../elementos/AutoDisablingButton";
import { Categoria } from "../DTO/Categoria";
import { useCategoriaStore } from "../store/CategoriaStore";
import toast from "react-hot-toast";
import {globalApiError} from "../utils/generalApiError";
import LoadingModal from "../elementos/LoadingModal";

interface FormularioCategoriaProps {
  id: string | null;
  categoria: Categoria | null;
}

const FormularioCategoria: React.FC<FormularioCategoriaProps> = ({ id, categoria }) => {
  const [nombre, setNombre] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { createCategoria, editarCategoria } = useCategoriaStore();

  useEffect(() => {
    if (categoria) {
      setNombre(categoria?.nombre);
    }
  }, [categoria]);

  useEffect(() => {
    setDisabled(false);
  }, []);

  const defaultObject = () => {
    setNombre("");
  };

  const validateForm = () => {
    return nombre.trim() === "";
  };

const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();
  
  if (!validateForm()) {
    try {
      setDisabled(true);
      setLoading(true);
      
      if (id === null) {
        await createCategoria(nombre);
        toast.success("Se ha creado la categoria correctamente");

      } else {
        if (categoria) {
          const categoriaActualizada: Categoria = {
            ...categoria,
            nombre: nombre
          };
          
          await editarCategoria(categoriaActualizada);
          toast.success("Se ha editado la categoria correctamente");
        }
      }
      navigate("/categorias");
      defaultObject();

    } catch (error) {
      toast.error(globalApiError(error));
    } finally {
      setDisabled(false);
      setLoading(false);
    }
  } else {
    toast.error("Debes completar todo el formulario");
  }
};
  return (
    <div className="container mt-4">
      <LoadingModal show={loading} message="Guardando categoría..." />
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input type="hidden" value={categoria?.id} />
          <label htmlFor="nombre" className="form-label">
            Nombre de la categoria
          </label>
          <input
            type="text"
            className="form-control"
            id="nombre"
            placeholder="Ej. Trabajo"
            required
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />
        </div>

        <AutoDisablingButton disabled={disabled}  type="submit" className="btn btn-success me-2">
          Guardar Categoria
        </AutoDisablingButton>

        <Link to={"/categorias"} className="btn btn-primary">
          {" "}
          Volver atras
        </Link>
      </form>
    </div>
  );
};

export default FormularioCategoria;
